import React, { useEffect, useState } from 'react';
import { translate } from '../../i18n';
import useDateStore from '../../store/selectedDateStore';
import useLocationStore from '../../store/locatonStore';
import {
  encodeDateForUrl,
  getAdjustedDate,
  getDaysFromToday,
} from '../../utils/dateUtils';
import complianceApi from '../../api/complianceApi';
import StaffComplianceSection from '../../components/ui/StaffComplianceSection';
import AirCraftComplianceSection from '../../components/ui/AirCraftComplianceSection';
import PilotSummary from '../../components/ui/PilotSummarySection';
import DriverSummarySection from '../../components/ui/DriverSummarySection';
import VehicleAndTrailerComplianceSection from '../../components/ui/VeicleAndTrailerCompliance';
import useUserStore from '../../store/userStore';
import useBgColorStore from '../../store/bgColor';
import { BallTriangle } from 'react-loader-spinner';
import { getLocationNameFromOwnerId } from '../../utils/utility';

const CompliancesDesktop = () => {
  const { bgColor } = useBgColorStore();
  const { selectedDateFromStore } = useDateStore();
  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const [apiResponse, setApiResponse] = useState<any>();
  const [selectedDate] = useState<Date>(
    selectedDateFromStore || getAdjustedDate(),
  );
  const id = useUserStore((state) => state?.user?.id);

  const [reloadKey, setReloadKey] = useState(0);
  const [driverAccordionIsOpen, setDriverAccordionIsOpen] = useState<
    boolean | undefined
  >(true);
  const [pilotSummaryAccordionIsOpen, setPilotSummaryAccordionIsOpen] =
    useState<boolean | undefined>(true);

  const [driverSummaryAccordionIsOpen, setDriverSummaryAccordionIsOpen] =
    useState<boolean | undefined>(true);

  const [
    complianceAircraftAccordionIsOpen,
    setComplianceAircraftAccordionIsOpen,
  ] = useState<boolean | undefined>(true);

  const [
    complianceVeichleAccordionIsOpen,
    setComplianceVeichleAccordionIsOpen,
  ] = useState<boolean | undefined>(true);

  const handleStaffChange = (
    type:
      | 'staffCompliance'
      | 'pilot'
      | 'crew'
      | 'booking'
      | 'aircraftCompliance'
      | 'veichleCompliance',
  ) => {
    if (type === 'staffCompliance') {
      setReloadKey((prevKey) => prevKey + 1);
      setDriverAccordionIsOpen(true);
    }
    if (type === 'aircraftCompliance') {
      setReloadKey((prevKey) => prevKey + 1);
      setComplianceAircraftAccordionIsOpen(true);
    }
    if (type === 'veichleCompliance') {
      setReloadKey((prevKey) => prevKey + 1);
      setComplianceVeichleAccordionIsOpen(true);
    }
  };

  useEffect(() => {
    fetchComplianceDetails();
  }, [selectedDate, selectedLocation.OwnerId, reloadKey]);
  const [loading, setLoading] = useState(false);
  const fetchComplianceDetails = async () => {
    try {
      setLoading(true);
      const encodedDate = encodeDateForUrl(selectedDate);
      const response = await complianceApi.getComplianceDetails(
        selectedLocation.OwnerId,
        encodedDate,
        id,
      );
      setApiResponse(response?.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const locationName = getLocationNameFromOwnerId(selectedLocation.OwnerId);

  return (
    <div className="h-screen flex flex-col bg-backgroundColor-darkThemeColor">
      <div className="mb-2 ">
        <div className="flex justify-between items-start bg-backgroundColor-darkThemeColor p-2">
          {/* Left Side */}
          <div className="ml-2 p-2">
            <h1 className="text-2xl font-semibold text-darkGrayColor mb-2">
              {locationName}
              {/* {selectedLocation.locationName} */}
            </h1>
            <p className="text-left text-textColor text-2xl mt-2 font-semibold">
              {translate('greetings.hello', {
                name: Array.isArray(apiResponse?.staffDetails?.staffName)
                  ? apiResponse?.staffDetails?.staffName[0]
                  : apiResponse?.staffDetails?.staffName,
              })}
            </p>
          </div>

          {/* Right Side */}
          <div className="mr-2 text-right text-base text-textColorGray space-y-2">
            <p>
              <span className="font-medium">
                {translate('compliances.passwordExpire')}
              </span>{' '}
              <span>
                {apiResponse?.staffDetails?.expiryDate
                  ? `${getDaysFromToday(apiResponse.staffDetails.expiryDate)} day(s)`
                  : '--'}
              </span>
            </p>
            <p>
              <span className="font-medium">
                {translate('compliances.lastLogin')}
              </span>{' '}
              <span>
                {apiResponse?.staffDetails?.lastLogon
                  ? new Date(
                      apiResponse.staffDetails.lastLogon,
                    ).toLocaleDateString()
                  : '--'}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="flex-1 bg-backgroundColor-darkThemeColor">
        {loading ? (
          <div className="flex flex-1 justify-center items-center">
            <BallTriangle
              height="80"
              width="80"
              color="#4fa94d"
              ariaLabel="loading"
              visible={true}
            />
          </div>
        ) : (
          <>
            {apiResponse?.upcomingStaffCompliance?.upcomingStaffCompliance
              ?.length > 0 && (
              <StaffComplianceSection
                data={
                  apiResponse.upcomingStaffCompliance.upcomingStaffCompliance
                }
                userCanEditStaffCompliance={
                  apiResponse?.upcomingStaffCompliance
                    ?.userCanEditStaffCompliance
                }
                onStaffChange={() => handleStaffChange('staffCompliance')}
                driverAccordionIsOpen={driverAccordionIsOpen}
                toggleState={setDriverAccordionIsOpen}
                userHavePermissionToUpdateStatusStaffCompliance={
                  apiResponse?.upComingStaffCompliance
                    ?.userHavePermissionToUpdateStatusStaffCompliance
                }
                userHavePermissionToReadStatusStaffCompliance={
                  apiResponse?.upcomingStaffCompliance
                    ?.userHavePermissionToReadStatusStaffCompliance
                }
              />
            )}

            {apiResponse?.vehicleAndTrailer?.vehicleAndTrailer?.length > 0 &&
              apiResponse?.vehicleAndTrailer
                ?.userHavePermissionToViewVeichleCompliance && (
                <VehicleAndTrailerComplianceSection
                  data={apiResponse.vehicleAndTrailer.vehicleAndTrailer}
                  writePermissionForEquipmentCompliance={
                    apiResponse.vehicleAndTrailer
                      .writePermissionForEquipmentCompliance
                  }
                  onStaffChange={() => handleStaffChange('veichleCompliance')}
                  driverAccordionIsOpen={complianceVeichleAccordionIsOpen}
                  toggleState={setComplianceVeichleAccordionIsOpen}
                  editPermissionForBalloonCompliance={
                    apiResponse?.vehicleAndTrailer
                      ?.readPermissionForVeichleCompliance
                  }
                />
              )}

            {apiResponse?.aircraft?.aircraft?.length > 0 &&
              apiResponse?.aircraft
                ?.userHavePermissionToViewAirCraftCompliance && (
                <AirCraftComplianceSection
                  data={apiResponse.aircraft.aircraft}
                  writePermissionForEquipmentCompliance={
                    apiResponse.aircraft.writePermissionForEquipmentCompliance
                  }
                  onStaffChange={() => handleStaffChange('aircraftCompliance')}
                  driverAccordionIsOpen={complianceAircraftAccordionIsOpen}
                  toggleState={setComplianceAircraftAccordionIsOpen}
                  editPermissionForBalloonCompliance={
                    apiResponse?.aircraft?.readPermissionForBalloonCompliance
                  }
                />
              )}

            {apiResponse?.pilotSummary?.length > 0 && (
              <PilotSummary
                data={apiResponse.pilotSummary}
                driverAccordionIsOpen={pilotSummaryAccordionIsOpen}
              />
            )}
            {apiResponse?.driverSummary?.length > 0 && (
              <DriverSummarySection
                data={apiResponse.driverSummary}
                driverAccordionIsOpen={driverSummaryAccordionIsOpen}
              />
            )}
            {apiResponse?.staffDetails &&
              !apiResponse?.upcomingStaffCompliance?.upcomingStaffCompliance
                ?.length &&
              !apiResponse?.vehicleAndTrailer?.vehicleAndTrailer?.length &&
              !apiResponse?.aircraft?.aircraft?.length &&
              !apiResponse?.pilotSummary?.length &&
              !apiResponse?.driverSummary?.length && (
                <div
                  className={`flex justify-center items-center ${bgColor} mt-4 rounded-md shadow-sm h-full`}
                >
                  <p className="text-text-blue text-base font-medium text-center">
                    Looks like there’s no data to display right now.
                  </p>
                </div>
              )}
          </>
        )}
      </div>
    </div>
  );
};

export default CompliancesDesktop;
